export default function initLoader() {
    // Simular carga o asegurar que se vea la animación
    setTimeout(() => {
        document.body.classList.add("PAGE-IS--LOADED");
        window.dispatchEvent(new CustomEvent("vantys:loader:start-fade"));
    }, 1500);

    const loader = document.getElementById("app-loader");

    if (loader) {
        loader.addEventListener(
            "transitionend",
            () => {
                loader.remove();
                window.dispatchEvent(new CustomEvent("vantys:loader:complete"));
            },
            { once: true }
        );
    }
}
